import apiManager from '../../api/api-manager';
import { parseDossierToDossierFilter } from '../../api/parsers/wallet-parsers';
import { DossierFilter } from '../../model';
import { AsyncThunkConfig } from '../../store/async-thunk-config';
import { DossierError } from '../../store/data/dossier';
import { getAPIRequestHeadersWithToken, GetThunkAPI } from '../../utils/api-utils';
import { DossierRepository } from './dossier-repository';

export const transitionDossierRepository: DossierRepository = {
  getDossier: async (
    thunkApi: GetThunkAPI<AsyncThunkConfig<DossierError>>
  ): Promise<DossierFilter> => {
    const user = thunkApi.getState().data.user;
    const token = user.tokenRubrica || user.token;
    const result = await apiManager.portafoglioApi.gerarchiaDossier(
      getAPIRequestHeadersWithToken(thunkApi, token)
    );
    return parseDossierToDossierFilter(result.data);
  },
};
